module.exports = __webpack_public_path__ + "static/media/A1-23-Dyplozen-cod121.a31e321a.png";